import React, { useEffect, useState } from 'react'
const Dashboard = () => {

  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUserName(parsedUser.username || "Guest");
        setRole(parsedUser.role || "Role");
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);


  return (
    <section className="dashboard section">
     <div className="row">
      <div className="col-xl-12 col-lg-12 col-md-12 col-12">
       <div className="row">
       <img src="" alt="" />
       <h3>
        Welcome to <span style={{ color: "darkred" }}>{role} Dashboard</span> 
      </h3>

       </div>
      </div>
     </div>
    </section>
  )
}

export default Dashboard